export default __webpack_public_path__ + "af99dd9d54b7e93e3218c447303aecdb.png";